import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { StepHeaderEntity } from "../../../../../entities/UIEntities/Form Entities/StepHeaderEntity";
import {
    ADD_CAMPAIGN_FORM_STEPS, CAMPAIGN_TYPES,
} from "../../../../../enums/Enums";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import store from "../../../../../redux/Store";
import Icons from "../../../../../resources/icons/Icons";
import Strings from "../../../../../resources/Strings";
import classes from "../WizardForm.module.css";
import MessagingAccordion from "../../../Accordion/MessagingAccordion/MessagingAccordion";
import MessagingRecipientsContentCard from "../../../Cards/MessagingContentCard/MessagingRecipientsContentCard";
import CampaignDetailsContentCard from "../../../Cards/MessagingContentCard/CampaignDetailsContentCard";
import { LENGTHS } from "../../../../../config/Config";

const CampaignReviewStep = (props) => {
  const [validRecipients, setValidRecipients] = useState({});
  const [stepHeader, setStepHeader] = useState(new StepHeaderEntity(
    Strings.STEPS_TITLES.CAMPAIGN_REVIEW_TITLE,
    null,
    Icons.MESSAGING,
    null
  ));
  
  // Get relevant messaging cost according to the selected campaign type mail / sms
  const relevantMessagingCost = useSelector((state) => props?.campaignType?.value === CAMPAIGN_TYPES.MAIL ? state.messaging.messagingCostsData?.emailPrice : state.messaging.messagingCostsData?.smsPrice);
  const messagingRecipientsContentCardRef = useRef();
  const totalCampaignPrice = `$ ${parseFloat(relevantMessagingCost * validRecipients?.length).toFixed(LENGTHS.TO_FIXED_LENGTH)}`

  useEffect(() => {
    if (props.currentStep === ADD_CAMPAIGN_FORM_STEPS.CAMPAIGN_REVIEW) {
      store.dispatch(commonActions.setSideModal({ modalHeader: stepHeader }));

      // For display number of emails and total cost
      setValidRecipients(messagingRecipientsContentCardRef?.current?.validRecipients);
    }
  }, [props.currentStep]); 

  if (props.currentStep !== ADD_CAMPAIGN_FORM_STEPS.CAMPAIGN_REVIEW) {
    return null;
  }
  
  return (
    <div className={classes.stepContainer}>
      <div className={classes.stepTitle}>
        {`${Strings.STEPS_TITLES.CAMPAIGN_REVIEW_TITLE}: ${props?.campaignName}`}
      </div>
      
      <div className={classes.messagingCard}>
        <MessagingAccordion 
          outerTitle={Strings.CAMPAIGN_DETAILS}
          contentCard={<CampaignDetailsContentCard {...props} />}
          {...props}
        />
        <MessagingAccordion 
          outerTitle={`${Strings.RECIPIENTS} (${validRecipients?.length})`}          
          contentCard={<MessagingRecipientsContentCard ref={messagingRecipientsContentCardRef} {...props} />}
          {...props}
        />
        <MessagingAccordion 
          outerTitle={`${Strings.CAMPAIGN_PRICE} (${totalCampaignPrice})`}
          detailsData={[
            {title: props?.campaignType?.value === CAMPAIGN_TYPES.MAIL ? `${Strings.EMAILS_NUMBER}` : `${Strings.TEXT_MESSAGES_NUMBER}`, value: validRecipients?.length}, 
            {title: props?.campaignType?.value === CAMPAIGN_TYPES.MAIL ? `${Strings.EMAILS_COST}` : `${Strings.TEXT_MESSAGES_COST}`, value: `$ ${parseFloat(relevantMessagingCost).toFixed(LENGTHS.TO_FIXED_LENGTH)}`}, 
            {title: `${Strings.TOTAL}`, value: totalCampaignPrice},
          ]}  
          {...props}
        />
      </div>  
    </div>
  );
};

export default CampaignReviewStep;
